import { Card, Form, Button, Input, Col, Row, Tooltip, Space } from 'antd';
import {
  useCompanyData,
  useSendTelegramTestMessage,
} from '../../../../../../../../Hooks/TT_ELD/Companies';
import { sendEvent } from '../../../../../../../../Utils/analytics';
import { companies } from '../../../../../../../../API/TT_ELD/Users/company';
import { InfoCircleOutlined } from '@ant-design/icons';
import { getProviderFromUrl } from '../../../../../../../../Utils/providerURL';
import { useProjectData } from '../../../../../../../../Hooks/useProjectData';

type MyObjectType = {
  [key: string | number]: any;
};

const ViolationsTab = ({ companyId }: { companyId: any }) => {
  const [form] = Form.useForm();
  const { data, isFetching, isLoading, refetch }: MyObjectType = useCompanyData(companyId);
  const { mutate, isLoading: isPending } = useSendTelegramTestMessage();

  const normalizeValue = (v: any) => v || null;

  const onSubmit = async (values: any) => {
    values = {
      ...values,
      chatId: normalizeValue(values.chatId),
      config: {
        ...values.config,
        eldType: await companies.latestEldType(companyId),
      },
    };
    const body: MyObjectType = {};

    let key: string | number;
    let key2: string | number;
    for (key in values) {
      if (typeof data[key] === 'object' && !Array.isArray(data[key]) && data[key] != null) {
        for (key2 in values[key]) {
          if (
            typeof values[key][key2] === 'object' &&
            !Array.isArray(values[key][key2]) &&
            values[key][key2] != null
          ) {
            if (JSON.stringify(values[key][key2]) != JSON.stringify(data[key][key2])) {
              body[key] = values[key];
              break;
            }
          } else if (data[key][key2] != values[key][key2]) {
            body[key] = values[key];
            break;
          }
        }
      } else if (data[key] != values[key]) {
        body[key] = values[key];
      }
    }

    sendEvent(
      `Company page`,
      `Company  Tab Notification  `,
      `Company page Tab Notification Submit`,
      1,
    );
    companies.companyPatchData(body, companyId);
    refetch();
  };

  const handleTestMessage = () => {
    const chatId = form.getFieldValue('chatId');

    if (!chatId) {
      return;
    }

    const payload = {
      chatId,
      botType: `eld`,
      message: 'Success! Your chat has been connected, and notifications will now be sent here',
    };

    mutate(payload);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  type FieldType = {
    notificationChatId?: number;
    notificationEmail?: string;
    type?: string;
    chatId?: string;
  };

  const { projectData } = useProjectData();

  const provider = getProviderFromUrl(projectData.baseUrl);

  return (
    <Card loading={isLoading || isFetching} style={{ width: '100%' }}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmit}
        onFinishFailed={onFinishFailed}
        name="violations"
        initialValues={{
          ...data,
        }}
      >
        <Row gutter={[16, 10]}>
          <Col xs={24} sm={24} md={12} lg={8}>
            <Form.Item
              label={
                <span>
                  Violations Chat ID{' '}
                  <span style={{ color: '#999' }}>
                    {`(Supported bots: @control_${provider}_bot)`}
                  </span>
                </span>
              }
              noStyle={false}
            >
              <Space.Compact style={{ width: '100%' }}>
                <Form.Item name="chatId" noStyle>
                  <Input placeholder="Enter Chat ID" style={{ flex: 1 }} />
                </Form.Item>

                <Button type="primary" loading={isPending} onClick={handleTestMessage}>
                  Test Message
                </Button>
              </Space.Compact>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default ViolationsTab;
